export enum TemplateStyle {
    ROUND = 'ROUND',
    SQUARE = 'SQUARE',
    PILL = 'PILL',
}
